var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 125,
    rx: 15,
    fill: "#97D3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.8465 32.6525L91.3923 104.957L62.38 113L33.4476 104.968L27 32.6525H97.8465Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4233 106.852L85.8667 100.353L91.382 38.5651H62.4233V106.852Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8764 56.3038H62.4233V47.4346H40.1835L40.3956 49.814L42.5757 74.2552H62.4233V65.386H50.687L49.8764 56.3038ZM51.8753 78.69H42.972L44.2144 92.616L62.3825 97.6592L62.4233 97.6481V88.4204L62.3844 88.4307L52.5068 85.7635L51.8753 78.69Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5914 13H38.0987V17.4531H42.2218V13H46.7293V26.485H42.2221V21.9695H38.0989V26.485H33.5917L33.5914 13ZM52.6562 17.472H48.6888V13H61.1341V17.472H57.1643V26.485H52.657V17.472H52.6562ZM63.1092 13H67.8089L70.6998 17.7383L73.588 13H78.2897V26.485H73.8008V19.8011L70.6998 24.5958H70.6221L67.5192 19.8011V26.485H63.1092V13ZM80.5327 13H85.0413V22.0278H91.3798V26.485H80.5324V13H80.5327Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3927 74.2552H73.3142L72.2844 85.758L62.3924 88.4279V97.6551L80.5749 92.616L80.7082 91.1175L82.7927 67.7677L83.009 65.386H62.3927V74.2552ZM62.3927 56.2821V56.3038H83.816L83.9938 54.3104L84.3981 49.814L84.61 47.4346H62.3927V56.2821Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlGroup);
export default __webpack_public_path__ + "static/media/HTMLGroup.e6a23c3581ae7984188393a338e1f021.svg";
export { ForwardRef as ReactComponent };